import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppRoles from "@/components/roles/appRoles/AppRoles";

const AppRolesPage = () => {
  const { appId } = useParams();
  const [applicationName, setApplicationName] = useState<string>("");

  const handleApplicationLoaded = (name: string) => {
    setApplicationName(name);
  };

  return (
    <>
      <AppRoles
        ApplicationId={Number(appId)}
        ShowOnlyNewAppRolePanel={false}
        onApplicationLoaded={handleApplicationLoaded}
        breadcrumbTitle="Application | Roles"
        breadcrumbSubtitle={
          applicationName ? (
            <>
              Manage roles for application <strong>{applicationName}</strong>
            </>
          ) : (
            "Manage roles for this application"
          )
        }
      />
    </>
  );
};

export default AppRolesPage;
